/**
 * Convert camelCase to dash-case properties.
 */
const camelToDash = str => str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
export { camelToDash };